import { useSearchParams, useNavigate } from 'react-router-dom';
import VerifyPage from '../../pages/verify/verify.page';
import ResetPasswordPage from '../../pages/password/reset-password.page';
import ModalComponent from '../../components/modal/modal.component';
import { ERROR_MODAL_CONTENT } from '../../constants';

const ActionHandlerPage = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const mode = searchParams.get('mode');

	if (mode === 'verifyEmail') return <VerifyPage />;
	if (mode === 'resetPassword') return <ResetPasswordPage />;

	return (
		<ModalComponent
			open
			title={ERROR_MODAL_CONTENT.title}
			description={ERROR_MODAL_CONTENT.description}
			imageSrc="/cambiapp_logo.png"
			buttonText="Volver al inicio"
			onClose={() => navigate('/login')}
			onButtonClick={() => navigate('/login')}
			showCloseButton={true}
		/>
	);
};

export default ActionHandlerPage;
